import { styled } from "@mui/material/styles";
import { Box, Typography, Button } from "@mui/material";

export const IgniteMainWrapper = styled(Box)({
  width: "100%",
});

export const BannerSection = styled(Box)({
  width: "100%",
  backgroundImage: `url(${process.env.PUBLIC_URL}/Assets/About/About-banner.jpg)`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  backgroundPosition: "center",
});

export const BannerContent = styled(Box)({
  padding: "60px 5%",
  width: "45%",
});

export const BannerTitle = styled(Typography)({
  color: "#FFFFFF",
  fontSize: "34px",
  fontWeight: 600,
});

export const AboutWrapper = styled(Box)({
  width: "90%",
  margin: "auto",
  padding: "40px 0",
});

export const AboutSection = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "stretch",
  gap: "80px",
});

export const AboutLeft = styled(Box)({
  flex: 1,
  maxWidth: "50%"
});

export const AboutTitle = styled(Typography)({
  fontSize: "22px",
  fontWeight: 600,
  marginBottom: "12px",
});

export const AboutDescription = styled(Typography)({
  fontSize: "14px",
  lineHeight: 1.6,
  color: "#000000",
  marginBottom: "25px",
});

export const StatsRow = styled(Box)({
  display: "flex",
  gap: "150px",
  marginBottom: "20px",
});

export const StatsRow1 = styled(Box)({
  display: "flex",
  gap: "150px",
});

export const StatItem = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "12px",
});

export const StatNumber = styled(Typography)({
  fontSize: "36px",
  fontWeight: 700,
  color: "#7500C0",
  lineHeight: 1,
});

export const StatText = styled(Typography)({
  fontSize: "13px",
  color: "#000000",
  lineHeight: 1.3,
  maxWidth: "90px",
});

export const StatBrand = styled(Typography)({
  fontSize: "36px",
  fontWeight: 700,
  color: "#7500C0",
});

export const AboutRight = styled(Box)({
  maxWidth: "30%",
  display: "flex",
});

export const CarnivalCard = styled(Box)({
  backgroundColor: "#452C70",
  border: "1px soild #460073",
  color: "#FFFFFF",
  padding: "28px 26px",
  position: "relative",
  flex: 1,
  alignItems: "center",
});

export const ThunderIcon = styled("img")({
  width: "80px",
  height: "80px",
  position: "absolute",
  top: "40px",
  left: "-36px",
  objectFit: "contain",
});

export const CarnivalTitle = styled(Typography)({
  paddingLeft: "20px",
  paddingTop: "40px",
  fontSize: "16px",
  fontWeight: 600,
  marginBottom: "40px",
});

export const CarnivalText = styled(Typography)({
  fontSize: "14px",
  lineHeight: 1.6,
});

export const VisionSection = styled(Box)({
  width: "100%",
  padding: "40px 0",
  background: "linear-gradient(90deg, #23032A 0%, #6E599A 100%)",
  display: "flex",
  justifyContent: "center",
});

export const VisionCard = styled(Box)({
  width: "90%",
  backgroundColor: "#FFFFFF",
  padding: "28px 36px",
});

export const VisionTitle = styled(Typography)({
  fontSize: "26px",
  fontWeight: 600,
  marginBottom: "8px",
  color: "#000000",
});

export const VisionText = styled(Typography)({
  fontSize: "16px",
  color: "#000000",
  lineHeight: 1.6,
});

export const JoySection = styled(Box)({
});

export const JoyHeader = styled(Box)({
  display: "flex",
  gap: "20px",
  alignItems: "flex-start",
  marginBottom: "30px",
});

export const JoyLeft = styled(Box)({
  width: "50%",
});

export const JoyRight = styled(Box)({
  width: "50%",
});

export const JoyTitle = styled(Typography)({
  fontSize: "26px",
  fontWeight: 600,
  lineHeight: 1.3,
});

export const JoyDescription = styled(Typography)({
  fontSize: "16px",
  lineHeight: 1.6,
  color: "#000000",
});

export const ImpactSection = styled(Box)({});

export const ImpactTitle = styled(Typography)({
  fontSize: "26px",
  fontWeight: 600,
  marginBottom: "4px",
});

export const ImpactYear = styled(Typography)({
  fontSize: "16px",
  fontWeight: 600,
  marginBottom: "20px",
});

export const ImpactGrid = styled(Box)({
  display: "grid",
  gridTemplateColumns: "repeat(2, 1fr)",
  gap: "16px 20px",
});

export const ImpactCard = styled(Box)({
  background: "#57008A",
  color: "#FFFFFF",
  padding: "18px 20px",
  minHeight: "88px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});

export const CardText = styled(Box)({});

export const CardLabel = styled(Typography)({
  fontSize: "12px",
  letterSpacing: "0.6px",
  opacity: 0.9,
  marginBottom: "6px",
});

export const CardValue = styled(Typography)({
  fontSize: "26px",
  fontWeight: 700,
  display: "flex",
  alignItems: "baseline",
  gap: "6px",
});

export const SmallText = styled("span")({
  fontSize: "12px",
  fontWeight: 400,
});

export const CardIcon = styled("img")({
  width: "36px",
  height: "36px",
  padding: "4px",
  objectFit: "contain",
  background: "#A100ff",
  borderRadius: "6px",
});

export const CardIcon1 = styled("img")({
  width: "36px",
  height: "36px",
  padding: "2px",
  paddingLeft: "6px",
  paddingTop: "6px",
  objectFit: "contain",
  background: "#A100ff",
  borderRadius: "6px",
});

export const ObjectivesWrapper = styled(Box)({
  width: "100%",
  margin: "auto",
  marginTop: "50px",
});

export const Title = styled("h2")({
  textAlign: "center",
  fontSize: "24px",
  fontWeight: 600,
  marginBottom: "48px",
});

export const ContentGrid = styled(Box)({
  display: "flex",
  justifyContent: "center",
});

export const Timeline = styled(Box)({
  position: "relative",
  width: "900px",
  height: "650px",
});

export const Spine = styled(Box)({
  position: "absolute",
  left: "50%",
  top: "34px",
  bottom: "2px",
  width: "2px",
  backgroundColor: "#57008A",
  transform: "translateX(-50%)",
});

export const NodeWrapper = styled(Box)(({ side, top }) => ({
  position: "absolute",
  top: `${top}px`,
  display: "flex",
  alignItems: "center",

  left: side === "left" ? "50%" : "50%",

  transform:
    side === "left"
      ? "translateX(-100%)"
      : "translateX(0)",

  flexDirection: side === "left" ? "row" : "row",
}));


export const Connector = styled(Box)({
  width: "28px",
  height: "2px",
  backgroundColor: "#57008A",
});

export const Dot = styled(Box)({
  width: "42px",
  height: "42px",
  borderRadius: "50%",
  backgroundColor: "#57008A",
  color: "#FFFFFF",
  fontSize: "14px",
  fontWeight: 600,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
});

export const NodeContent = styled(Box)({
  maxWidth: "370px",
  paddingLeft: "30px",
});

export const ItemTitle = styled("h3")({
  fontSize: "18px",
  fontWeight: 600,
  marginBottom: "8px",
});

export const ItemDesc = styled("p")({
  fontSize: "14px",
  lineHeight: "20px",
  color: "#000000",
});

export const BottomCap = styled(Box)({
  position: "absolute",
  bottom: 0,
  left: "50%",
  width: "16px",
  height: "2px",
  backgroundColor: "#57008A",
  transform: "translateX(-50%)",
});

export const BannerWrapper = styled(Box)({
  width: "100%",
  height: "140px",
  background: "linear-gradient(90deg, #23032A 0%, #6E599A 100%)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

export const BannerText = styled("p")({
  maxWidth: "1000px",
  color: "#FFFFFF",
  fontSize: "18px",
  lineHeight: "26px",
  textAlign: "center",
  fontWeight: 500,
  margin: 0,
});